export default "__VITE_ASSET__DcaXM4Dz__"